import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import MaconnerieBernay from "@/pages/MaconnerieBernay";
import RenovationBernay from "@/pages/RenovationBernay";
import ExtensionMaison from "@/pages/ExtensionMaison";
import OuvertureMurPorteur from "@/pages/OuvertureMurPorteur";
import BetonExterieurs from "@/pages/BetonExterieurs";
import ZonesIntervention from "@/pages/ZonesIntervention";
import MaconnerieEvreux from "@/pages/MaconnerieEvreux";
import RenovationEvreux from "@/pages/RenovationEvreux";
import LocalPage from "@/pages/LocalPage";
import ServicePage from "@/pages/ServicePage";
import Realisations from "@/pages/Realisations";
import ChantierPage from "@/pages/ChantierPage";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDevis from "@/pages/AdminDevis";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function FloatingChrome({ chatReady }) {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <>
      <MobileCTA />
      {chatReady && <ChatWidget />}
    </>
  );
}

function App() {
  const [chatReady, setChatReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setChatReady(true), 2500);
    const lenis = new Lenis({ lerp: 0.12, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="bg-[#0A0A0A] min-h-screen" data-testid="app-root">
        <div className="noise-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/maconnerie-bernay" element={<MaconnerieBernay />} />
            <Route path="/renovation-bernay" element={<RenovationBernay />} />
            <Route path="/extension-maison" element={<ExtensionMaison />} />
            <Route path="/ouverture-mur-porteur" element={<OuvertureMurPorteur />} />
            <Route path="/beton-amenagements-exterieurs" element={<BetonExterieurs />} />
            <Route path="/gros-oeuvre" element={<ServicePage slug="gros-oeuvre" />} />
            <Route path="/construction-murs" element={<ServicePage slug="construction-murs" />} />
            <Route path="/fondations" element={<ServicePage slug="fondations" />} />
            <Route path="/dalles-beton" element={<ServicePage slug="dalles-beton" />} />
            <Route path="/rejointoiement" element={<ServicePage slug="rejointoiement" />} />
            <Route path="/parement-brique" element={<ServicePage slug="parement-brique" />} />
            <Route path="/maconnerie-evreux" element={<MaconnerieEvreux />} />
            <Route path="/renovation-evreux" element={<RenovationEvreux />} />
            <Route path="/maconnerie-beuzeville" element={<LocalPage slug="beuzeville" />} />
            <Route path="/maconnerie-louviers" element={<LocalPage slug="louviers" />} />
            <Route path="/maconnerie-conches-en-ouche" element={<LocalPage slug="conches-en-ouche" />} />
            <Route path="/maconnerie-pont-audemer" element={<LocalPage slug="pont-audemer" />} />
            <Route path="/maconnerie-thiberville" element={<LocalPage slug="thiberville" />} />
            <Route path="/maconnerie-deauville" element={<LocalPage slug="deauville" />} />
            <Route path="/zones" element={<ZonesIntervention />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/chantiers/:slug" element={<ChantierPage />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/admin" element={<Navigate to="/admin/devis" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/devis" element={<AdminDevis />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <FloatingChrome chatReady={chatReady} />
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </BrowserRouter>
  );
}

export default App;
